module.exports = __webpack_public_path__ + "src/img/zoomSmall.93b352fc.svg";